import {
  handleSettingsAddMachines,
  handleSettingsMachineSelectAlt,
} from '../../../components/store/slices/settings/force&CommandAndAdminSelectSlice';

export const selectMachineIndicatorDispatcherHandler = (
  dispatch,
  name,
  locationIdx,
  specLocationIdx,
  machineIdx,
  newSelectedMachine,
  select = true
) => {
  dispatch(
    handleSettingsMachineSelectAlt({
      switch: name,
      locationIdx,
      specLocationIdx,
      machineIdx,
      status: select,
    })
  );
  dispatch(
    handleSettingsAddMachines({
      switch: name,
      arr: newSelectedMachine,
    })
  );
};
